<div class="chat flex justify-between items-center gap-2 mt-3">
  <div class="chat__icons">
    <offconon-material-icon
      class="chat__icon"
      [fontIcon]="iconsVisible ? 'chevron_left' : 'add_circle_outline'"
      (iconClick)="toggleIcons()" />
  </div>
  <div *ngIf="iconsVisible" class="chat__icons">
    <offconon-material-icon class="chat__icon" fontIcon="mic" (iconClick)="sendVoiceMessage()" />
    <offconon-material-icon class="chat__icon" fontIcon="image" (iconClick)="sendImage()" />
    <offconon-material-icon class="chat__icon" fontIcon="gif" (iconClick)="sendGif()" />
  </div>

  <div class="relative flex flex-1 items-center">
    <textarea
      #messageInput
      rows="1"
      pTextarea
      type="text"
      pInputText
      placeholder="Aa"
      class="w-full pr-10"
      autofocus
      size="large"
      [autoResize]="true"
      (keyup.enter)="sendMessage(messageInput.value)"></textarea>
    <button class="hidden" (click)="sendMessage(messageInput.value)">Send</button>
  </div>
  <div class="chat__icons items-center gap-2">
    <offconon-material-icon
      class="chat__icon"
      fontIcon="thumb_up"
      (iconClick)="sendLike(messageInput)" />
    <div class="emoji-on">
      <offconon-material-icon
        fontIcon="sentiment_satisfied"
        class="flex cursor-pointer"
        (click)="toggleEmojiMart()" />
      @if (emojiVisible) {
        <emoji-mart
          [showPreview]="false"
          [color]="'#0085c6'"
          (emojiSelect)="sendEmoji($event, messageInput)" />
      }
    </div>
  </div>
</div>
